import {AnalyticsProvider} from "@zeg/shared/analytics-provider";
import {ErrorBoundary} from "@zeg/shared/components/error-boundary";
import {LoadingOverlay} from "@zeg/ui/LoadingOverlay";
import {Toaster} from "@zeg/ui/Sonner";
import {PropsWithChildren, Suspense} from "react";
import {ThemeProvider} from "./theme-provider";

export function Providers({children}: PropsWithChildren) {
  return (
    <Suspense fallback={<LoadingOverlay isLoading={true} />}>
      <ThemeProvider>
        <AnalyticsProvider>
          <ErrorBoundary>
            <Toaster />
            {children}
          </ErrorBoundary>
        </AnalyticsProvider>
      </ThemeProvider>
    </Suspense>
  );
}
